import { useCallback} from "react";
import { useMutation } from "../base";
import { Role } from "myfitworld-model";
import globalState, { GlobalState } from "../../globalState";
import { updateUserOrganizations, updateOrganizationUserDocument } from "../../api/usersApi";
import { useIntl } from "react-intl";
import organizationsMessages from "./messages";

export interface OrgInUser{
  id: string;
  role: Role;
  archived?: boolean | undefined;
}

function useUpdateOrganizationClient() {
  const {formatMessage} = useIntl();

  const updateOrganizationClientQuery = useCallback(async ({userId, archived, orgId, organizations}:{userId: string; archived?: boolean; orgId?: string; organizations: OrgInUser[]})=>{
    try {
      await updateUserOrganizations({id: userId, archived, organizations: organizations});
      if (archived !== undefined && orgId) {
        await updateOrganizationUserDocument(userId, orgId, { archived });
      }
      return;
    } catch (error) {
      globalState.update((state:GlobalState)=>{
        state.toastQueue.push({
          message: formatMessage(organizationsMessages.error_updating_Organizations_In_User),
          severity:"error"
        })
      }) 
      throw error
    }
  }, [formatMessage]);


  const { status, error, isLoading } = useMutation(updateOrganizationClientQuery);
  return {
    status,
    error,
    isLoading,
    updateOrganizationClientQuery,
  };
}
export default useUpdateOrganizationClient;
